const getItemId = ({ variantId, productId }) => variantId || productId;

export default getItemId;
